import React from 'react'

import { useFormContext, Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useRegimesMexValues } from '@/core/hooks/misc/useAlegraConstants'
import { Input } from '@/shared/components/atoms/Input'
import { Label } from '@/shared/components/atoms/Label/Label'
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@/shared/components/atoms/Select'

import { BillingInformationFormData } from '../BillingInformation.types'

export const AlegraMexFields: React.FC = () => {
	const { t } = useTranslation('common')
	const {
		register,
		control,
		formState: { errors },
	} = useFormContext<BillingInformationFormData>()
	const regimesMexValues = useRegimesMexValues()

	return (
		<>
			<div className="flex flex-col gap-2 md:col-span-2">
				<Label htmlFor="municipality">
					{t('account.billing_information.municipality')} *
				</Label>
				<Input
					id="municipality"
					{...register('municipality')}
					className="bg-input"
					maxLength={500}
					aria-invalid={!!errors.municipality}
				/>
				{errors.municipality && (
					<p className="text-sm text-destructive">
						{errors.municipality.message}
					</p>
				)}
			</div>
			<div className="flex flex-col gap-2">
				<Label htmlFor="ext_number">
					{t('account.billing_information.ext_number')}
				</Label>
				<Input
					id="ext_number"
					{...register('ext_number')}
					className="bg-input"
					maxLength={10}
				/>
				{errors.ext_number && (
					<p className="text-sm text-destructive">
						{errors.ext_number.message}
					</p>
				)}
			</div>
			<div className="flex flex-col gap-2">
				<Label htmlFor="int_number">
					{t('account.billing_information.int_number')}
				</Label>
				<Input
					id="int_number"
					{...register('int_number')}
					className="bg-input"
					maxLength={10}
				/>
				{errors.int_number && (
					<p className="text-sm text-destructive">
						{errors.int_number.message}
					</p>
				)}
			</div>
			<div className="flex flex-col gap-2 md:col-span-2">
				<Label htmlFor="regime">
					{t('account.billing_information.regime')}
				</Label>
				<Controller
					name="regime"
					control={control}
					render={({ field }) => (
						<Select
							value={field.value || 'GENERAL_REGIME_OF_MORAL_PEOPLE_LAW'}
							onValueChange={field.onChange}
						>
							<SelectTrigger
								className="bg-input w-full"
								aria-invalid={!!errors.regime}
							>
								<SelectValue />
							</SelectTrigger>
							<SelectContent>
								{regimesMexValues.map((regime) => (
									<SelectItem key={regime.value} value={regime.value}>
										{regime.label}
									</SelectItem>
								))}
							</SelectContent>
						</Select>
					)}
				/>
				{errors.regime && (
					<p className="text-sm text-destructive">{errors.regime.message}</p>
				)}
			</div>
		</>
	)
}
